(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alphav-product-reassurance"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('alphav-product-reassurance'))customElements.define('alphav-product-reassurance',class extends HTMLElement{
    connectedCallback(){this.refresh=()=>this.updateDates();this.updateDates();document.addEventListener('visibilitychange',this.refresh);window.addEventListener('pageshow',this.refresh)}
    disconnectedCallback(){clearTimeout(this.timer);document.removeEventListener('visibilitychange',this.refresh);window.removeEventListener('pageshow',this.refresh)}
    dateAfter(now,days){return new Date(Date.UTC(now.getFullYear(),now.getMonth(),now.getDate()+days,12))}
    updateDates(){
      clearTimeout(this.timer);const now=new Date();const locale=this.dataset.locale.startsWith('es')?'es-ES':'en-US';const format=new Intl.DateTimeFormat(locale,{weekday:'long',month:'long',day:'numeric',timeZone:'UTC'});
      for(const key of ['min','max']){const target=this.querySelector('[data-avr-'+key+']');if(target){const date=this.dateAfter(now,Number(this.dataset[key]));target.dateTime=date.toISOString().slice(0,10);target.textContent=format.format(date)}}
      const dynamic=this.querySelector('[data-avr-dynamic]');if(dynamic){dynamic.hidden=false;this.querySelector('[data-avr-fallback]').hidden=true}
      const midnight=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1);this.timer=setTimeout(this.refresh,midnight.getTime()-now.getTime()+100);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
